export const WEB_SKIP_ZIP_FLAG = 'web_skip_zip_v1'

export function isSkipZipTreatment(variant: string | boolean | undefined): boolean {
  return variant === true || variant === 'test'
}

/** Keep an in-progress flow stable across flag reloads and OAuth navigation. */
export function readSkipZipAssignment(): boolean | null {
  try {
    const value = sessionStorage.getItem(WEB_SKIP_ZIP_FLAG)
    return value === 'true' ? true : value === 'false' ? false : null
  } catch {
    return null
  }
}

export function saveSkipZipAssignment(value: boolean): void {
  try { sessionStorage.setItem(WEB_SKIP_ZIP_FLAG, String(value)) } catch { /* Storage is optional. */ }
}
